/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StaticPageNestedCalculator } from './StaticPageNestedCalculator'
import {
  StaticPageNestedCalculatorFromJSON,
  StaticPageNestedCalculatorFromJSONTyped,
  StaticPageNestedCalculatorToJSON,
} from './StaticPageNestedCalculator'

/**
 *
 * @export
 * @interface StaticPageAdmin
 */
export interface StaticPageAdmin {
  /**
   *
   * @type {number}
   * @memberof StaticPageAdmin
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof StaticPageAdmin
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof StaticPageAdmin
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof StaticPageAdmin
   */
  header?: string | null
  /**
   *
   * @type {string}
   * @memberof StaticPageAdmin
   */
  titleTag?: string | null
  /**
   *
   * @type {string}
   * @memberof StaticPageAdmin
   */
  descriptionTag?: string | null
  /**
   *
   * @type {string}
   * @memberof StaticPageAdmin
   */
  canonicalUrl?: string | null
  /**
   *
   * @type {number}
   * @memberof StaticPageAdmin
   */
  serviceId?: number | null
  /**
   *
   * @type {StaticPageNestedCalculator}
   * @memberof StaticPageAdmin
   */
  readonly calculator: StaticPageNestedCalculator | null
}

/**
 * Check if a given object implements the StaticPageAdmin interface.
 */
export function instanceOfStaticPageAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'slug' in value
  isInstance = isInstance && 'name' in value
  isInstance = isInstance && 'calculator' in value

  return isInstance
}

export function StaticPageAdminFromJSON(json: any): StaticPageAdmin {
  return StaticPageAdminFromJSONTyped(json, false)
}

export function StaticPageAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StaticPageAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    slug: json['slug'],
    name: json['name'],
    header: !exists(json, 'header') ? undefined : json['header'],
    titleTag: !exists(json, 'titleTag') ? undefined : json['titleTag'],
    descriptionTag: !exists(json, 'descriptionTag') ? undefined : json['descriptionTag'],
    canonicalUrl: !exists(json, 'canonicalUrl') ? undefined : json['canonicalUrl'],
    serviceId: !exists(json, 'serviceId') ? undefined : json['serviceId'],
    calculator: StaticPageNestedCalculatorFromJSON(json['calculator']),
  }
}

export function StaticPageAdminToJSON(value?: StaticPageAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    slug: value.slug,
    name: value.name,
    header: value.header,
    titleTag: value.titleTag,
    descriptionTag: value.descriptionTag,
    canonicalUrl: value.canonicalUrl,
    serviceId: value.serviceId,
  }
}
